<template>
  <div class="create-ticket">
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Submit a ticket</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <v-row v-if="item">
            <v-col cols="12" md="7" lg="7" xl="8" class="ticket-info">
              <v-form>
                <v-text-field label="Summary" dense outlined></v-text-field>
                <v-select
                  label="Priority"
                  :items="['Low', 'Medium', 'High']"
                  dense
                  outlined
                >
                </v-select>
                <h5 class="black--text">Description:</h5>
                <vue-editor
                  class="mt-1 mb-3"
                  :editorToolbar="customToolbar"
                ></vue-editor>

                <v-btn color="primary" depressed class="px-4 mr-1"
                  >Submit</v-btn
                >
                <v-btn
                  color="black"
                  depressed
                  outlined
                  class="px-4"
                  @click="$emit('close')"
                  >Cancel</v-btn
                >
              </v-form>
            </v-col>
            <v-col cols="12" md="5" lg="5" xl="4">
              <div class="text-center">
                <v-img
                  width="100%"
                  height="150"
                  src="@/assets/images/HS.png"
                  contain
                ></v-img>
              </div>

              <v-row no-gutters>
                <v-col cols="4">
                  <strong class="black--text">Mark:</strong>
                </v-col>
                <v-col cols="8">
                  <span class="black--text">{{ item.mark }}</span>
                </v-col>
                <v-col cols="4">
                  <strong class="black--text">Level:</strong>
                </v-col>
                <v-col cols="8">
                  <span class="black--text">{{ item.level_name }}</span>
                </v-col>
                <v-col cols="4">
                  <strong class="black--text">Window:</strong>
                </v-col>
                <v-col cols="8">
                  <span class="black--text"
                    >{{ item.series_name || "N/A" }},
                    {{ item.type_name || "N/A" }}</span
                  >
                </v-col>
                <v-col cols="4">
                  <strong class="black--text">Schedule:</strong>
                </v-col>
                <v-col cols="8">
                  <span class="black--text"
                    >Version {{ version ? version.number : "N/A" }}</span
                  >
                </v-col>
                <v-col cols="4">
                  <strong class="black--text">Est Price:</strong>
                </v-col>
                <v-col cols="8">
                  <span class="black--text">$133</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    version: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"]
      ]
    };
  }
};
</script>

<style scoped>
.ticket-info {
  border-right: 1px solid #ddd;
}
</style>
